import { AuthService } from "@/app/services/auth/auth.service";
import { UserService } from "@/app/services/user/user.service";
import { AsyncPipe, NgIf, NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, effect, inject, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { heroCog, heroDocumentText, heroHome, heroUser } from "@ng-icons/heroicons/outline";
import { filter } from "rxjs/operators";

@Component({
	selector: "corely-toolbar",
	templateUrl: "./corely-toolbar.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgOptimizedImage, MatButtonModule, NgIconComponent, NgIf, AsyncPipe, RouterModule],
	providers: [
		provideIcons({
			heroHome,
			heroUser,
			heroCog,
			heroDocumentText
		})
	]
})
export class CorelyToolbarComponent implements OnInit {
	public auth = inject(AuthService);
	public userService = inject(UserService);
	public router = inject(Router);
	public notInLogin = signal(true);
	public usuario = this.userService.usuario;

	public menuAbierto = false;

	toggleMenu() {
		this.menuAbierto = !this.menuAbierto;
	}

	closeMenu() {
		setTimeout(() => (this.menuAbierto = false), 150);
	}

	logout() {
		this.auth.logout();
		this.menuAbierto = false;
	}

	constructor() {
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			const url = this.router.url;
			this.notInLogin.set(!url.includes("login"));
		});

		console.log("[Toolbar] Constructor usuario:", this.usuario());

		effect(() => {
			console.log("[Toolbar] Signal usuario changed:", this.usuario());
		});
	}

	ngOnInit() {
		this.userService.getUsuario().subscribe();
	}
}
